"use strict";

$ ->
	max = 12
	col = if $(window).width() > 490 then 6 else 3
	$open = ''
	isOpen = false
	for j in [0...max/col]
		for i in [0...col]
			$($('.prof')[j*col + i]).insertBefore $($('.thm')[(j+1)*col])

	$('.thm')
		.on 'click', (e)->
			e.preventDefault()
			e.stopPropagation()
			$t = $( "##{$(@).attr('href')}" )
			if !isOpen
				down $t
			else
				if $t.is(':visible')
					up()
				else
					down $t
		.each ()->
			$(@).attr( 'href', $(@).attr('href').substr(1) )

	$('body').on 'click', (e)->
		up() if isOpen 

	down = ($t)->
		if isOpen
			$open.css {
				position:'absolute'
				top: $open.position().top
			}
			$open.fadeOut 200, ()->
				$(@).css {
					position:'relative'
					top: ''
				}
			$open = $t.fadeIn 200
		else
			$open = $t.slideDown(500)
		$('.thm').removeClass('on').addClass 'off'
		$(".thm[href='#{$t.attr('id')}']").removeClass('off').addClass 'on'
		isOpen = true

	up = ()->
		$open.slideUp(300)
		$('.thm').removeClass 'off'
		$(".thm[href='#{$open.attr('id')}']").removeClass('on')
		isOpen = false
		$open = null

	if location.hash isnt '' and $(location.hash)?
		setTimeout ()->
			down $(location.hash)
		, 500

	@